var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"ManageTop"}},[_c('div',[_c('Header')],1),_c('main',[_c('section',{staticClass:"regist_container"},[_c('h3',[_vm._v("機能一覧")]),_c('form',[_c('div',{staticClass:"regist_inputs_container"},[(_vm.currentServices.length > 0)?_c('div',_vm._l((_vm.currentServices),function(service){return _c('TheCard',{key:service.id,attrs:{"icon":service.icon,"title":service.title},on:{"click":() =>
                  _vm.handleTransferScreen(
                    service.destination,
                    service.routerType
                  )}})}),1):_vm._e()])])])]),_c('div',[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }